import * as linkedin2fa from './linkedin2fa'
import * as linkedinAiResearchOptOut from './linkedinAiResearchOptOut'
import * as linkedinConnectionsList from './linkedinConnectionsList'
import * as linkedinDeletePostsBefore from './linkedinDeletePostsBefore'
import * as linkedinEmailVisibility from './linkedinEmailVisibility'
import {
  getAccountUsernameGatherStageDefs,
  getAdditionalFullGatherStageDefs,
  isAccountDataGathered,
} from './linkedinGatherMachine'
import * as linkedinLocationVisibility from './linkedinLocationVisibility'
import * as linkedinNotifications from './linkedinNotifications'
import * as linkedinProfileDiscoverability from './linkedinProfileDiscoverability'
import * as linkedinRepresentCompany from './linkedinRepresentCompany'
import * as linkedinShowProfilePhoto from './linkedinShowProfilePhoto'
import * as linkedinStatusVisibility from './linkedinStatusVisibility'
import { LinkedinRecommendationKey } from '../../utils/enums'
import {
  RecommendationAutomationRegistryApi,
  RecommendationAutomationRegistry,
} from '../automationMachineInterfaces'

const REGISTRY: RecommendationAutomationRegistry = {
  [LinkedinRecommendationKey.LINKEDIN_LOCATION_VISIBILITY]:
    linkedinLocationVisibility,
  [LinkedinRecommendationKey.LINKEDIN_EMAIL_VISIBILITY]:
    linkedinEmailVisibility,
  [LinkedinRecommendationKey.LINKEDIN_CONNECTIONS_LIST]:
    linkedinConnectionsList,
  [LinkedinRecommendationKey.LINKEDIN_REPRESENT_COMPANY]:
    linkedinRepresentCompany,
  [LinkedinRecommendationKey.LINKEDIN_PROFILE_DISCOVERABILITY]:
    linkedinProfileDiscoverability,
  [LinkedinRecommendationKey.LINKEDIN_STATUS_VISIBILITY]:
    linkedinStatusVisibility,
  [LinkedinRecommendationKey.LINKEDIN_2FA]: linkedin2fa,
  [LinkedinRecommendationKey.LINKEDIN_NOTIFICATION_PREFERENCES]:
    linkedinNotifications,
  [LinkedinRecommendationKey.LINKEDIN_AI_RESEARCH_OPT_OUT]:
    linkedinAiResearchOptOut,
  [LinkedinRecommendationKey.LINKEDIN_SHOW_PROFILE_PHOTO]:
    linkedinShowProfilePhoto,
  [LinkedinRecommendationKey.LINKEDIN_DELETE_POSTS_BEFORE]:
    linkedinDeletePostsBefore,
}

export const linkedinRegistry: RecommendationAutomationRegistryApi = {
  getAccountUsernameGatherStageDefs: () => getAccountUsernameGatherStageDefs(),
  getAdditionalFullGatherStageDefs: () => getAdditionalFullGatherStageDefs(),
  getRecommendationAutomationRegistry: () => REGISTRY,
  isAccountDataGathered: (accountData) => isAccountDataGathered(accountData),
}
